module.exports = {
  clientId: 'saber', // 客户端id
  clientSecret: 'saber_secret', // 客户端密钥
  tokenKey: 'saber-access-token',
  refreshTokenKey: 'saber-refresh-token',
  title: '物业管理系统',
  noLogoTitle: '物业',
  storeKey: 'vd',
  tokenRefreshTime: 3000, //token刷新时间，单位秒
  timeout: 30000, //请求超时时间
  showLoading: false, //是否显示加载圈
  parseResp: true, //是否自动处理返回值
  withHeaders: true, //是否传入请求头
  vHeaders: {}, //自定义请求头
  pageName: 'page', //当前第几页字段名
  limitName: 'limit', //每页笔数字段名
  countName: 'count', //返回总笔数字段名
  codeName: 'code', //返回码字段名
  dataName: 'data', //返回数据字段名
  descName: 'msg', //返回描述字段名
  codeSuccess: 200, //成功返回码
  codeTokenError: 401, //token错误返回码
  codeBusinessError: 400, //业务错误码
};
